import React, { useState } from 'react';
import './PromptModal.css';

const PromptModal = ({ 
  isOpen, 
  onClose, 
  onSubmit, 
  title, 
  message,
  placeholder = '',
  defaultValue = '',
  confirmText = 'Submit',
  cancelText = 'Cancel'
}) => {
  const [value, setValue] = useState(defaultValue);
  const [submitting, setSubmitting] = useState(false);

  // Reset value when modal opens/closes
  React.useEffect(() => {
    if (isOpen) {
      setValue(defaultValue);
    } else {
      setValue('');
    }
  }, [isOpen, defaultValue]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!value.trim()) return;
    if (!onSubmit) return;

    try {
      setSubmitting(true);
      // Await the async submit; parent decides when to close
      await onSubmit(value);
    } catch (err) {
      // Keep the modal open so user can retry
      // console.error('Prompt submit failed', err);
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    if (submitting) return;
    onClose();
    setValue('');
  };

  return (
    <div className="prompt-modal-overlay" onClick={handleClose}>
      <div className="prompt-modal-content" onClick={(e) => e.stopPropagation()}>
        <form onSubmit={handleSubmit}>
          <div className="prompt-modal-header">
            <h3>{title}</h3>
          </div>
          <div className="prompt-modal-body">
            {message && <p>{message}</p>}
            <input
              type="text"
              className="prompt-input"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder={placeholder}
              autoFocus
              disabled={submitting}
            />
          </div>
          <div className="prompt-modal-actions">
            <button type="button" className="btn-cancel" onClick={handleClose}>
              {cancelText}
            </button>
            <button type="submit" className="btn-submit" disabled={!value.trim() || submitting}>
              {submitting ? 'Submitting...' : confirmText}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PromptModal;
